import styled, { css } from 'styled-components'

import theme from 'theme_'

export const RadioInputWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: ${theme.spacing.base};

  @media ${theme.devices.tablet} {
    display: inline-flex;
    margin-bottom: 0;
  }
`

export const StyledRadioInput = styled.input`
  appearance: none;
  flex: none;
  display: block;
  position: relative;
  z-index: 1;
  border: 1px solid ${theme.colors.horizonOrange};
  width: 24px;
  height: 24px;
  border-radius: 50%;
  cursor: pointer;

  ${(p) =>
    p.checked &&
    css`
      &:after {
        content: '';
        display: block;
        position: absolute;
        z-index: 2;
        top: 4px;
        left: 4px;
        width: 14px;
        height: 14px;
        background-color: ${theme.colors.horizonOrange};
        border-radius: 50%;
      }
    `}

  ${(p) =>
    p.disabled &&
    css`
      opacity: 0.7;
      cursor: default;
    `}
`

export const RadioInputLabel = styled.label`
  padding-left: ${theme.spacing.base};
  cursor: pointer;
`
